import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { ApplicationState } from '../../../../../core/models/application-state/application-state';
import { FormGroupType } from '../../../../../core/models/form-group-type';
import { ApplicationCreationResponse } from '../../../shared/models/responses/application-creation-response';
import { ApplicationStateService } from '../../../shared/services/application-state/application-state.service';
import { ApplicationTemplateService } from '../../../shared/services/application-template/application-template.service';
import { ApplicationTemplateExistsRequest } from '../../shared/models/application-template-exists-request';
import { ApplicationTemplateRequest } from '../../shared/models/application-template-form-model';
import { ApplicationTemplateFormService } from '../../shared/services/application-template-form/application-template-form.service';
import { ApplicationTemplateFormDialogComponent } from '../application-template-form-dialog/application-template-form-dialog.component';
import { ApplicationTemplateCreationFromApplicationRequest } from './models/application-template-creation-from-application-request';

@Component({
    selector: 'app-application-template-creation-from-application-form',
    templateUrl: `./application-template-creation-from-application-form.component.html`,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ApplicationTemplateFormDialogComponent],
})
export class ApplicationTemplateCreationFromApplicationFormComponent
    implements OnDestroy
{
    private destroy$ = new Subject<void>();

    applicationState: ApplicationState | null =
        this.applicationStateService.getCurrentApplicationState();

    form: FormGroup<FormGroupType<ApplicationTemplateRequest>> =
        this.applicationTemplateFormService.getTemplateForm();

    constructor(
        private readonly applicationTemplateFormService: ApplicationTemplateFormService,
        private readonly applicationStateService: ApplicationStateService,
        private readonly applicationTemplateService: ApplicationTemplateService,
        private readonly dialogRef: MatDialogRef<ApplicationTemplateCreationFromApplicationFormComponent>,
    ) {}

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    /**
     * Calls the application template service to create a new template.
     */
    createTemplate(): void {
        this.applicationTemplateService
            .createTemplateFromApplication(this.generateRequestObject())
            .subscribe(
                (applicationCreationResponse: ApplicationCreationResponse) => {
                    this.closeDialog(applicationCreationResponse);
                },
            );
    }

    closeDialog(
        applicationCreationResponse: ApplicationCreationResponse | null = null,
    ): void {
        this.dialogRef.close(applicationCreationResponse);
    }

    checkTemplateNameExistence(): void {
        this.applicationTemplateFormService.checkTemplateNameExistence(
            this.form,
            this.generateApplicationTemplateExistsRequest(),
        );
    }

    private generateRequestObject(): ApplicationTemplateCreationFromApplicationRequest {
        const formValue = this.form
            .value as Required<ApplicationTemplateCreationFromApplicationRequest>;

        return {
            ...formValue,
            applicationMasterId: this.applicationState!.applicationId!,
        };
    }

    private generateApplicationTemplateExistsRequest(): ApplicationTemplateExistsRequest {
        return {
            applicationTemplateId: null,
            name: this.form.controls.name.value!,
        };
    }
}
